module.exports = __webpack_public_path__ + "static/media/buenos-aires-al-aire-libre.75bf7527.md";